import { type CSSProperties, useEffect, useRef, useState } from "react";

export function useTriggerWidth<T extends HTMLElement>(isOpen?: boolean) {
  const triggerRef = useRef<T>(null);
  const [triggerWidth, setTriggerWidth] = useState<number>(0);

  useEffect(() => {
    if (isOpen === false) return;
    if (!triggerRef.current) return;
    setTriggerWidth(triggerRef.current.offsetWidth);
  }, [isOpen]);

  const triggerWidthStyle: CSSProperties | undefined =
    triggerWidth > 0
      ? {
          width: `${triggerWidth}px`,
          minWidth: `${triggerWidth}px`,
        }
      : undefined;

  return {
    triggerRef,
    triggerWidth,
    triggerWidthStyle,
  };
}
